import { Link } from 'react-router-dom'
import { FC } from 'react'
import { AUTH_PATH } from '~/app/lib/paths'
import Icon from '../../utils/Icon'
import Text from '../../utils/Text/Text'

interface MailSentProps {
  onResendLink: () => void
}

const MailSent: FC<MailSentProps> = ({ onResendLink }) => {
  return (
    <div className="space-y-14">
      <div className="flex flex-col items-center gap-5">
        <Icon name="sms" size={64} color="var(--primary)" />
        <Text type="headline-4" color="800">
          Email sent!
        </Text>
        <Text type="body-1" color="600" className="text-center">
          Please check your email. We have sent you an email that contains a link to reset your
          password.
        </Text>
      </div>
      <Text type="body-3" color="500" className="w-full text-center">
        Don&apos;t receive the email? Please check your spam or{' '}
        <span className="cursor-pointer font-bold text-primary" onClick={onResendLink}>
          Resend link.
        </span>
      </Text>
      <Link to={AUTH_PATH.SIGN_IN} className="flex-center">
        <Icon name="arrow-left-2" color="var(--primary)" size={24} className="mr-2" />
        <Text type="title-2" color="primary">
          Back to Sign in
        </Text>
      </Link>
    </div>
  )
}

export default MailSent
